module.exports = __webpack_public_path__ + "img/tw.aae7b504.svg";